import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-383bce02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-container participant" }
const _hoisted_2 = { class: "alert-text-container" }
const _hoisted_3 = { class: "musical-dna-container" }
const _hoisted_4 = { class: "musical-dna_header" }
const _hoisted_5 = { class: "musical-dna_body" }
const _hoisted_6 = { class: "favorite-musical-styles-container" }
const _hoisted_7 = { class: "favorite-musical-periods-container" }
const _hoisted_8 = { class: "favorite-musical-artists-container" }
const _hoisted_9 = { class: "favorite-songs-container" }
const _hoisted_10 = { class: "action-container" }
const _hoisted_11 = { class: "notification-container" }
const _hoisted_12 = { class: "memory-container" }
const _hoisted_13 = { class: "header-container" }
const _hoisted_14 = { class: "logo-container" }
const _hoisted_15 = { class: "text-container" }
const _hoisted_16 = { class: "body-container" }
const _hoisted_17 = { class: "memory-pop-up" }
const _hoisted_18 = { class: "filter-memory" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "icon-container" }
const _hoisted_21 = { class: "month-filter" }
const _hoisted_22 = { class: "month-filter-icon" }
const _hoisted_23 = { class: "dropdown-content" }
const _hoisted_24 = { class: "contents" }
const _hoisted_25 = {
  key: 0,
  class: "memory-card-cont"
}
const _hoisted_26 = {
  key: 1,
  class: "memory-no-content"
}
const _hoisted_27 = { class: "pagination-items" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-memory-pop-up" }, null, -1))
const _hoisted_29 = { class: "questionnaire-parent" }
const _hoisted_30 = {
  key: 0,
  class: "questionnairePopup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Confirm = _resolveComponent("Confirm")!
  const _component_Header = _resolveComponent("Header")!
  const _component_FavoriteCard = _resolveComponent("FavoriteCard")!
  const _component_NotificationButton = _resolveComponent("NotificationButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Memory = _resolveComponent("Memory")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_QuestionnaireModal = _resolveComponent("QuestionnaireModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isFirstConnectionPopup)
        ? (_openBlock(), _createBlock(_component_Confirm, {
            key: 0,
            data: _ctx.firstConnectionPopupData
          }, {
            alertBody: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.dashboard.profile.firstConnectionMessage')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.dashboard.profile.firstConnectionConfirm')), 1)
              ])
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Header, {
            title: _ctx.$t('views.dashboard.profile.myMusicalDna'),
            "bg-color": "#ffff",
            "title-color": "#36AEC1",
            "title-align": "flex-start"
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FavoriteCard, {
              title: _ctx.$t('views.dashboard.profile.myMusicalStyles'),
              "no-item-text": _ctx.$t('views.dashboard.profile.noFavoriteGenre'),
              items: _ctx.favoriteGenresItems,
              "item-type": _ctx.QuestionnaireType.Genre,
              "logo-size": "3.5em",
              "on-edit": 
                            () => {
                                _ctx.onEdit(_ctx.QuestionnaireType.Genre);
                            }
                        
            }, null, 8, ["title", "no-item-text", "items", "item-type", "on-edit"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FavoriteCard, {
              title: _ctx.$t('views.dashboard.profile.myFavoritePeriods'),
              "no-item-text": _ctx.$t('views.dashboard.profile.noFavoritePeriod'),
              items: _ctx.favoritePeriodsItems,
              "item-type": _ctx.QuestionnaireType.Period,
              "logo-size": "3.5em",
              "on-edit": 
                            () => {
                                _ctx.onEdit(_ctx.QuestionnaireType.Period);
                            }
                        
            }, null, 8, ["title", "no-item-text", "items", "item-type", "on-edit"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FavoriteCard, {
              title: _ctx.$t('views.dashboard.profile.myFavoriteArtists'),
              "no-item-text": _ctx.$t('views.dashboard.profile.noFavoriteArtist'),
              items: _ctx.favoriteArtistsItems,
              "item-type": _ctx.QuestionnaireType.Artist,
              "logo-size": "6em",
              "on-edit": 
                            () => {
                                _ctx.onEdit(_ctx.QuestionnaireType.Artist);
                            }
                        
            }, null, 8, ["title", "no-item-text", "items", "item-type", "on-edit"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FavoriteCard, {
              title: _ctx.$t('views.dashboard.profile.myLastFavoriteSongs'),
              "no-item-text": _ctx.$t('views.dashboard.profile.noFavoriteSong'),
              items: _ctx.favoriteTrackItems,
              "item-type": _ctx.QuestionnaireType.Track,
              "logo-size": "6em",
              "on-edit": 
                            () => {
                                _ctx.onEdit(_ctx.QuestionnaireType.Track);
                            }
                        
            }, null, 8, ["title", "no-item-text", "items", "item-type", "on-edit"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_NotificationButton, {
              text: _ctx.$t('generic.survey'),
              logo: "fa-user",
              "on-click": 
                            () => {
                                _ctx.onEdit(_ctx.QuestionnaireType.List);
                            }
                        ,
              count: _ctx.newParticipantQuestionnaireCount
            }, null, 8, ["text", "on-click", "count"]),
            _withDirectives(_createVNode(_component_NotificationButton, {
              text: _ctx.$t('generic.network'),
              logo: "fa-users"
            }, null, 8, ["text"]), [
              [_vShow, false]
            ]),
            _withDirectives(_createVNode(_component_NotificationButton, {
              text: _ctx.$t('generic.photos'),
              logo: "fa-camera"
            }, null, 8, ["text"]), [
              [_vShow, false]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-camera-retro" })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.memory', 0)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileMemories, (memory) => {
              return (_openBlock(), _createElementBlock("div", {
                key: memory.id,
                class: "memories"
              }, [
                _createVNode(_component_Memory, {
                  memory: memory,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleAllSouvenirs()))
                }, null, 8, ["memory"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.isShowAllMemory)
            ? (_openBlock(), _createBlock(_component_Confirm, {
                key: 0,
                data: _ctx.allMemoryPopupData,
                maxWidth: "90vw",
                maxHeight: "95vh"
              }, {
                alertHeader: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("form", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "search-filter",
                        placeholder: _ctx.$t('components.sidebar.search'),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSearchedText && _ctx.handleSearchedText(...args)))
                      }, null, 40, _hoisted_19), [
                        [_vModelText, _ctx.searchedText]
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "search-icon",
                          icon: "fa-magnifying-glass"
                        })
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown", { 'dropdown-active': _ctx.isDropdownOpen }]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDropdownOpen = !_ctx.isDropdownOpen))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", _hoisted_22, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-calendar-day" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.selectedDatePeriod), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: "option",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getFilteredData(30)))
                          }, [
                            _createElementVNode("span", null, " 1 " + _toDisplayString(_ctx.$t('generic.month')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "option",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getFilteredData(90)))
                          }, [
                            _createElementVNode("span", null, " 3 " + _toDisplayString(_ctx.$t('generic.month')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "option",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getFilteredData(180)))
                          }, [
                            _createElementVNode("span", null, " 6 " + _toDisplayString(_ctx.$t('generic.month')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "option",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getFilteredData(270)))
                          }, [
                            _createElementVNode("span", null, " 9 " + _toDisplayString(_ctx.$t('generic.month')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "option",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getFilteredData(365)))
                          }, [
                            _createElementVNode("span", null, " 1 " + _toDisplayString(_ctx.$t('generic.year')), 1)
                          ])
                        ])
                      ])
                    ], 2)
                  ])
                ]),
                alertBody: _withCtx(() => [
                  (_ctx.currentMemories.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMemories, (memory) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: memory.id,
                            class: "all-memories"
                          }, [
                            _createVNode(_component_Memory, {
                              memory: memory,
                              "on-play": _ctx.handlePlayButton,
                              onClick: () => _ctx.handleEditSouvenirPopup(memory)
                            }, null, 8, ["memory", "on-play", "onClick"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.souvenir.noMemoryFound')), 1)
                      ])),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Paginator, {
                      totalItems: _ctx.allMemories,
                      currentItems: _ctx.currentMemories,
                      currentPage: _ctx.souvenirSelectedPageNumber,
                      getCurrentPage: _ctx.getCurrentPage
                    }, null, 8, ["totalItems", "currentItems", "currentPage", "getCurrentPage"])
                  ])
                ]),
                _: 1
              }, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_28
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_ctx.showQuestionnairePopup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createVNode(_component_QuestionnaireModal, {
              "on-cancel": _ctx.closePopup,
              data: _ctx.questionnaireData,
              isModal: true,
              "on-submit": _ctx.onSubmitQuestionnaire,
              "open-result": _ctx.isPopupFinalResult,
              "check-answered-questionnaire": _ctx.checkAnsweredQuestionnaire,
              "on-row-click": _ctx.onOpenEval,
              "open-list-view": _ctx.onEdit
            }, {
              headerLeftButton: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args))),
                  class: "close-btn"
                }, "X")
              ]),
              _: 1
            }, 8, ["on-cancel", "data", "on-submit", "open-result", "check-answered-questionnaire", "on-row-click", "open-list-view"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}